// extracted by mini-css-extract-plugin
export default {"box":"form4_box__ZiaM1"};